import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const photos = [
  { alt: "électrification volet roulant Somfy installée à Strasbourg", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/feb84a2a99fbcd7e8ff78c3e17f09320.jpeg" },
  { alt: "passage manuel électrique Somfy volet roulant Bas-Rhin", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg" },
  { alt: "moteur Somfy posé dans coffre de volet existant Strasbourg", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7bf14301ee7a6b604645c9ec2aebae83.jpeg" },
  { alt: "télécommande Somfy programmée après électrification Bas-Rhin", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg" },
  { alt: "technicien électrifiant un volet manuel à Strasbourg", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/567ae914b096be40c10eb487428e7174.jpeg" },
  { alt: "volet roulant manuel transformé en électrique Somfy", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a2515f1fc094fd8ff5b758d413294b54.jpeg" },
];

export default function Galerie() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-3">
          Nos réalisations d'électrification Somfy
        </h2>
        <p className="text-brand-text text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Découvrez nos chantiers d'électrification de volets roulants manuels en Somfy à Strasbourg et dans le Bas-Rhin.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {photos.map((photo) => (
            <div
              key={photo.alt}
              className="relative rounded-xl overflow-hidden border border-brand-border bg-white aspect-[4/3]"
            >
              <ImagePlaceholder
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}